import { getTheme } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Slider } from 'office-ui-fabric-react/lib/Slider';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component, Fragment } from 'react';
import ImmocomContext from '../../contexts/ImmocomContext';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataContact } from '../../data/DataContact';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUITextField } from '../EUI/EUITextField';
import { FicheContact } from '../Fiche/FicheContact/FicheContact';
import { FicheContactTransfertPropriete } from '../Fiche/FicheContactTransfertPropriete';
import { FicheDenonciation } from '../Fiche/FicheDenonciation';

export class DetailsListContact extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListContactWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListContactWithPerimetre extends Component {

    static contextType = ImmocomContext;

    static defaultProps = {
        perimetre: {}
    };

    static defaultState = {
        afficherDialogSuppressionContact: false,
        afficherPanelContact: false,
        afficherPanelDenonciation: false,
        afficherPanelFiltres: false,
        afficherPanelTransfertPropriete: false,
        appelFicheContactEnModeCreation: false,
        estAdministrateurDesContacts: false, // Ne semble plus être utilisé
        estAffectation: false,
        facteurNbreEnregistrement: 100,
        idContact: null,
        items: [],
        itemsSelectionnes: [],
        pageIndex: 1,
        peutAffecterA: false,
        peutCreerDesContacts: false,
        peutRetirerA: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListContactWithPerimetre.defaultState };
        this._columns = this._getColumns();
        this._filtres = {};
        this._isSortedDescending = true;
        this._sortedColumn = "creerLe";
        this._theme = getTheme();
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this.setState({ pageIndex: 1 });
        this._togglePanel("Filtres", false, null, this._chargementDonnees)();
    };

    _chargementDonnees = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement des contacts en cours...");

        const { facteurNbreEnregistrement, pageIndex } = this.state;
        const { recherche, idSociete, loginCompte, nomContact, loginProprietaire, loginCreateur, dateCreation, dateModification } = this._filtres;
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataContact._chargementListeDesCONTACTS(facteurNbreEnregistrement, recherche, tri, pageIndex, idSociete, loginCompte, nomContact, loginProprietaire, loginCreateur, dateCreation, dateModification).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const newItems = objetData[0] || [];
                const peutCreerDesContacts = objetData[1];
                const estAdministrateurDesContacts = objetData[2];
                const peutAffecterA = objetData[3];
                const peutRetirerA = objetData[4];

                let items = [];
                if (pageIndex === 1) items = newItems;
                else {
                    items = [...this.state.items];
                    items = items.concat(newItems);
                }

                const state = { estAdministrateurDesContacts, items, peutAffecterA, peutCreerDesContacts, peutRetirerA };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                fetchMessages(responseFetch);
                const state = {
                    estAdministrateurDesContacts: false,
                    items: [],
                    peutAffecterA: false,
                    peutCreerDesContacts: false,
                    peutRetirerA: false,
                };
                this.setState(state);
            }
            dismissMessage(messageId);
        });

    };

    _closePanelContact = (rechargerLesDonnees) => {
        let callback, stateUpdates;
        if (rechargerLesDonnees) callback = this._chargementDonnees;
        else {
            // Marquer le contact comme visualisé (sans recharger la liste complète)
            const { idContact, items } = this.state;
            let contacts = [...items];
            const index = contacts.findIndex(contact => contact.idContact === idContact);
            if (index >= 0) {
                contacts[index].visualiserLe = true;
                stateUpdates = { items: contacts };
            };
        }
        this._togglePanel("Contact", false, stateUpdates, callback)();
    };

    _getColumns = () => {

        return [{
            key: 'nomContact',
            name: 'Contact',
            onRender: (item) => {
                const nomContact = item.nomContact;
                return <Stack horizontal gap="5px">
                    <span title={nomContact}>{nomContact}</span>
                    {!item.visualiserLe && <span style={{ color: this._theme.palette.themePrimary }}>nouveau !</span>}
                </Stack>;
            }
        }, {
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            key: 'tel1',
            minWidth: 100,
            maxWidth: 150,
            name: 'Mobile',
        }, {
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            key: 'tel2',
            minWidth: 100,
            maxWidth: 150,
            name: 'Fixe',
        }, {
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            key: 'email',
            minWidth: 100,
            maxWidth: 200,
            name: 'Email',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: 'ville',
            minWidth: 150,
            maxWidth: 300,
            name: 'Ville',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: 'modifierLe',
            name: 'Dernière modification',
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            key: 'proprietaireEnCours',
            minWidth: 200,
            maxWidth: 300,
            name: 'Propriétaire',
        }, {
            ariaLabel: 'Modifier le contact',
            isIconOnly: true,
            key: 'edition',
            onRender: (item) => item.contact_Acceder
                ? <IconButton
                    ariaLabel="Edition"
                    iconProps={{ iconName: 'EditContact' }}
                    onClick={this._togglePanel("Contact", true, { idContact: item.idContact, appelFicheContactEnModeCreation: false })}
                    title="Modifier le contact"
                />
                : null
        }, {
            ariaLabel: 'Supprimer le contact',
            isIconOnly: true,
            key: 'delete',
            onRender: (item) => item.contact_Supprimer
                ? <IconButton
                    ariaLabel="Suppression"
                    iconProps={{ iconName: 'Delete' }}
                    onClick={this._toggleDialog("SuppressionContact", true, { idContact: item.idContact })}
                    title="Supprimer le contact"
                />
                : null
        }];

    };

    _getItems = () => {

        const { itemsSelectionnes, peutCreerDesContacts, peutAffecterA, peutRetirerA } = this.state;
        let items = [];

        if (peutCreerDesContacts)
            items.push({
                iconProps: { iconName: 'Add' },
                key: 'nouveauContact',
                name: 'Nouveau contact',
                onClick: this._togglePanel("Contact", true, { idContact: 0, appelFicheContactEnModeCreation: true })
            });

        if (peutAffecterA) {
            items.push({
                disabled: itemsSelectionnes.length === 0,
                iconProps: { iconName: 'PageEdit' },
                key: 'estAffectation',
                name: 'Poser des dénonciations',
                onClick: this._togglePanel("Denonciation", true, { estAffectation: true })
            });
        }

        if (peutRetirerA)
            items.push({
                disabled: itemsSelectionnes.length === 0,
                iconProps: { iconName: 'PageRemove' },
                key: 'retirer',
                name: 'Enlever des dénonciations',
                onClick: this._togglePanel("Denonciation", true, { estAffectation: false })
            });

        if (peutAffecterA)
            items.push({
                disabled: itemsSelectionnes.length === 0,
                iconProps: { iconName: 'Switch' },
                key: 'transfert',
                name: 'Transfert de propriété',
                onClick: this._togglePanel("TransfertPropriete", true)
            });

        return items;

    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onCounterClick = () => {
        this.setState(prevState => ({
            facteurNbreEnregistrement: prevState.facteurNbreEnregistrement > 0 ? -1 : DetailsListContactWithPerimetre.defaultState.facteurNbreEnregistrement,
            pageIndex: 1
        }), this._chargementDonnees
        );
    };

    _onScroll = () => {
        const { facteurNbreEnregistrement } = this.state;
        if (facteurNbreEnregistrement > 0)
            this.setState(
                prevState => ({ pageIndex: prevState.pageIndex + 1 }),
                this._chargementDonnees
            );
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onSuppressionContact = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Suppression du contact en cours...");

        const { idContact } = this.state;

        DataContact._onSuppressionContact(idContact).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                // MG - 23/02/2022 - retirer le contact supprimé du state pour recharger
                this.setState(prevState => ({ items: prevState.items.filter(item => item.idContact !== this.state.idContact) }));
            }
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _toggleDialog = (nomDialog, isOpen, stateUpdates, callback) => () => {
        if (typeof stateUpdates !== 'object') stateUpdates = {};
        if (typeof callback !== 'function') callback = null;
        this.setState(
            {
                [`afficherDialog${nomDialog}`]: isOpen,
                ...stateUpdates
            },
            callback
        );
    };

    _togglePanel = (nomPanel, isOpen, stateUpdates, callback) => () => {
        if (typeof stateUpdates !== 'object') stateUpdates = {};
        if (typeof callback !== 'function') callback = null;
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                ...stateUpdates
            },
            callback
        );
    };

    //componentDidUpdate = () => {

    //    //*************************************************************
    //    //ne marche pas
    //    //if(this.props.onRecharge === true)
    //    //    this._chargementDonnees();
    //    //*************************************************************

    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    //    }

    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const {
            afficherDialogSuppressionContact, afficherPanelContact, afficherPanelDenonciation, afficherPanelFiltres, afficherPanelTransfertPropriete,
            appelFicheContactEnModeCreation, estAffectation, facteurNbreEnregistrement, idContact, items, itemsSelectionnes
        } = this.state;

        return <Fragment>

            <EUIDetailsList
                columns={this._columns}
                getKey={item => item.idContact}
                isLazyLoadingEnabled={facteurNbreEnregistrement > 0}
                isSortedDescending={this._isSortedDescending}
                items={items}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onCounterClick={this._onCounterClick}
                onFilterButtonClick={this._togglePanel("Filtres", true)}
                onSearch={this._onSearch}
                onSelectionChanged={items => this.setState({ itemsSelectionnes: items })}
                onScroll={this._onScroll}
                selectionMode={SelectionMode.multiple}
                sortedColumn={this._sortedColumn}
            />

            <FicheContact
                appelFicheContactEnModeCreation={appelFicheContactEnModeCreation}
                idContact={idContact}
                isOpen={afficherPanelContact}
                onAnnuleFiche={reload => this._closePanelContact(reload)}
                onEnregistrementFiche={() => this._closePanelContact(true)}
                pasDAccesAHistorique={false}
                pasDAccesAuxDenonciations={false}
                pasDAccesAuxSouhaits={false}
                pasDAccesAuxSouhaitsMaisonIndividuelle={false}
            />

            <FicheDenonciation
                estAffectation={estAffectation}
                isOpen={afficherPanelDenonciation}
                listeIdContacts={itemsSelectionnes.map(contact => contact.idContact)}
                onDismiss={this._togglePanel("Denonciation", false, null, this._chargementDonnees)}
                onSave={this._togglePanel("Denonciation", false, null, this._chargementDonnees)}
            />

            <FicheContactTransfertPropriete
                isOpen={afficherPanelTransfertPropriete}
                listeIdContacts={itemsSelectionnes.map(contact => contact.idContact)}
                onDismiss={this._togglePanel("TransfertPropriete", false, null, this._chargementDonnees)}
                onSave={this._togglePanel("TransfertPropriete", false, null, this._chargementDonnees)}
            />

            <PanelFiltres
                filtres={this._filtres}
                isOpen={afficherPanelFiltres}
                onValidate={this._appliquerFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="save" onClick={this._toggleDialog("SuppressionContact", false, {}, this._onSuppressionContact)} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionContact", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionContact}
                onDismiss={this._toggleDialog("SuppressionContact", false)}
                titre="Suppression du contact"
            >
                Attention, vous êtes en train de supprimer un contact, souhaitez-vous continuer ?
            </EUIDialog>

        </Fragment>;
    };

};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
    };

    static defaultState = {
        dateCreation: 2015,
        dateModification: 2015,
        idSociete: 0, // N'est plus utilisé mais existe encore dans l'appel à l'API
        loginCompte: '', // N'est plus utilisé mais existe encore dans l'appel à l'API
        loginCreateur: '',
        loginProprietaire: '',
        nomContact: '',
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { dateCreation, dateModification, loginCreateur, loginProprietaire, nomContact } = this.state;
        const thisYear = new Date().getFullYear();

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >

            <EUITextField
                label="Contact"
                maxLength={MaxLengths.contact.nom}
                onChange={(event, newValue) => this.setState({ nomContact: newValue })}
                placeholder="Contact"
                value={nomContact}
            />

            <EUITextField
                label="Login compte propriétaire"
                maxLength={MaxLengths.contact.proprietaireEnCours}
                onChange={(event, newValue) => this.setState({ loginProprietaire: newValue })}
                placeholder="Login compte propriétaire"
                value={loginProprietaire}
            />

            <EUITextField
                label="Login compte créateur"
                maxLength={MaxLengths.contact.creerPar}
                onChange={(event, newValue) => this.setState({ loginCreateur: newValue })}
                placeholder="Login compte créateur"
                value={loginCreateur}
            />

            <Slider
                label="Date de création (année)"
                max={thisYear}
                min={2015}
                onChange={value => this.setState({ dateCreation: value })}
                showValue
                step={1}
                styles={{ root: { paddingTop: 5 } }}
                value={dateCreation}
                valueFormat={value => value === 2015 ? 'Toutes' : value}
            />

            <Slider
                label="Date de modification (année)"
                max={thisYear}
                min={2015}
                onChange={value => this.setState({ dateModification: value })}
                showValue
                step={1}
                value={dateModification}
                valueFormat={value => value === 2015 ? 'Toutes' : value}
            />

        </EUIPanel>;

    };

};